export const BALL_SLICE_NAME = 'ball';

export interface BallSliceState {
  isVisible: boolean;
  xPosition?: number;
  rowIndex?: number;
  isDraggable: boolean;
  animation: BallAnimation[] | null;
}

export interface BallAnimation {
  fromXPosition?: number;
  toXPosition: number;
  duration: number;
  rowIndex?: number;
}
